// Customer.js
import React from "react";
import CustomerPortal from "./Customer-comp";

const Customer = () => {
  return <CustomerPortal />;
};

export default Customer;
